import { cva } from 'class-variance-authority';
export const pillStyling = cva('px-4 py-2 rounded-full text-xs whitespace-nowrap', {
    variants: {
        variant: {
            default: 'bg-gray-50 text-gray-800',
            success: 'bg-green-50 text-green-800',
            error: 'bg-red-50 text-red-800',
            info: 'bg-blue-50 text-blue-800',
            warning: 'bg-yellow-50 text-yellow-800',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
